export const InteriorStyles = [
  'scandi',
  'industrial',
  'farmhouse',
  'minimalism',
  'boho',
  'mid_century',
  'japandi',
  'shabby_chic',
] as const;
export type InteriorStyle = (typeof InteriorStyles)[number];
export const interiorStyles = InteriorStyles.values().toArray();

export const CameraPositions = [
  'low-angle shot',
  'eye-level shot',
  'high-angle shot',
  'elevated shot',
] as const;
export type CameraPosition = (typeof CameraPositions)[number];
export const cameraPositions = CameraPositions.values().toArray();
